import { AccessControlTypes } from '../constants/AccessControlTypes';
import { PublicAccessRuleTypes } from '../constants/PublicAccessRuleTypes';
export const getContentAccessControlStateFromContent = ({
  password,
  publicAccessRules,
  publicAccessRulesEnabled,
  isSSOEnabled
}) => {
  const publicAccessRule = publicAccessRules[0] && publicAccessRules[0].type;
  const publicAccessRuleIds = publicAccessRules[0] ? publicAccessRules[0].ids : [];
  const dataWallPreviewEnabled = !!(publicAccessRules[0] && publicAccessRules[0].wallPreviewEnabled);
  const contentAccessControlState = {
    accessPassword: password,
    accessIds: publicAccessRuleIds,
    dataWallPreviewEnabled,
    accessControlType: AccessControlTypes.PUBLIC
  };
  switch (publicAccessRule) {
    case PublicAccessRuleTypes.PUBLIC:
      {
        contentAccessControlState.accessControlType = AccessControlTypes.PUBLIC;
        break;
      }
    case PublicAccessRuleTypes.PASSWORD:
      {
        contentAccessControlState.accessControlType = AccessControlTypes.PASSWORD;
        break;
      }
    case PublicAccessRuleTypes.MEMBERSHIP_LOGIN:
      {
        contentAccessControlState.accessControlType = AccessControlTypes.SELF_REGISTRATION;
        break;
      }
    case PublicAccessRuleTypes.LIST_MEMBERSHIP:
      {
        // Backwards compatible setup for SSO with lists
        if (isSSOEnabled) {
          contentAccessControlState.accessControlType = AccessControlTypes.SSO_WITH_LISTS;
          break;
        }
        contentAccessControlState.accessControlType = AccessControlTypes.LIST_REGISTRATION;
        break;
      }
    case PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP:
      {
        if (isSSOEnabled) {
          contentAccessControlState.accessControlType = AccessControlTypes.SSO_WITH_ACCESS_GROUPS;
          break;
        }
        contentAccessControlState.accessControlType = AccessControlTypes.ACCESS_GROUP_MEMBERSHIP;
        break;
      }
    case PublicAccessRuleTypes.SSO_LOGIN:
      {
        contentAccessControlState.accessControlType = AccessControlTypes.SSO;
        break;
      }
    case PublicAccessRuleTypes.SSO_WITH_LIST_MEMBERSHIP:
      {
        contentAccessControlState.accessControlType = AccessControlTypes.SSO_WITH_LISTS;
        break;
      }
    default:
      {
        // Backwards compatible setup for password access. When a user first selects password, the input field is blank. To distinguish between this initial selection and the public access option, we also interpret '' as password being selected
        if ((password || password === '') && !publicAccessRulesEnabled) {
          contentAccessControlState.accessControlType = AccessControlTypes.PASSWORD;
        }
      }
  }
  return contentAccessControlState;
};